export const CURRENCIES = ['EUR', 'CHF', 'GBP', 'USD', 'DKK', 'NOK', 'SEK'] as const;
export const SCALES_DERIVATIVES = ['THOUSAND', 'THOUSANDS', 'MILLIONS', 'MILLION', 'MIL'] as const;

export const RESPONSE_STATUS = {
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
} as const;

export const KEYS = {
    ESCAPE: 'Escape',
    ENTER: 'Enter',
    ARROW_UP: 'ArrowUp',
    ARROW_RIGHT: 'ArrowRight',
    ARROW_DOWN: 'ArrowDown',
    ARROW_LEFT: 'ArrowLeft',
    LOWER_I: 'i',
} as const;